import React from 'react';
import { useTheme } from '@mui/material/styles';
import { ThemedSvgProps } from '../../types';

const TriangleRackBase: React.FC<ThemedSvgProps> = ({ color, size = 60, className }) => {
  const theme = useTheme();
  const fill = color || theme.palette.venue.snooker;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
      className={className}
    >
      {/* Triangle rack outline */}
      <path
        d="M50 18 L85 82 L15 82 Z"
        stroke={fill}
        strokeWidth="3"
        strokeLinejoin="round"
        fill="none"
      />

      {/* Row 1 - 1 ball (top) */}
      <circle cx="50" cy="38" r="8" fill={fill} opacity={1.0} />

      {/* Row 2 - 2 balls */}
      <circle cx="42" cy="55" r="8" fill={fill} opacity={0.8} />
      <circle cx="58" cy="55" r="8" fill={fill} opacity={0.7} />

      {/* Row 3 - 3 balls (bottom) */}
      <circle cx="34" cy="72" r="8" fill={fill} opacity={0.6} />
      <circle cx="50" cy="72" r="8" fill={fill} opacity={0.5} />
      <circle cx="66" cy="72" r="8" fill={fill} opacity={0.9} />
    </svg>
  );
};

export const TriangleRack = React.memo(TriangleRackBase);
